import { tracker } from './analytic';

$(document).ready(function() {
  let $formSelector = $("form#reward_form_submission");

  // Disable reward form submit function, to force user use the wizard form
  $formSelector.on('submit', function (e) {
    e.preventDefault();
  });

  // Validate all required fields
  $formSelector.validate({
    errorClass: 'error-validation',
    errorPlacement: function errorPlacement(error, element) { element.after(error); }
  });

  // Auto add .required class to all labels with required field
  $('input[required], textarea[required], select[required]').each(function() {
    let $this = $(this);
    let $label = $('label[for="'+ $this.attr('id') +'"]');
    if ($label.length > 0 && $(this).attr('data-label-type') !== 'radio' && $(this).attr('data-label-type') !== 'checkbox') {
      $label.addClass("required");
    }
  });

  // Turn all select with select2 class into select2 field
  $('select.select2').select2({ theme: 'bootstrap' });
  $('.select2').each(function() {
    if ($(this).attr('data-dependent-field-visibility') === 'hidden') {
      $(this).next(".select2-container").addClass('d-none');
    }
    setTimeout(() => {
      if ($(this).val()) {
        $(this).trigger('change');
      }
    }, 0);
  });


  $('.datepicker').each(function() {

    $(this).datepicker({
      format: "yyyy-mm-dd",
      onSelect: function (dateText) {
        Cookies.set($(this).attr('id'), dateText, { expires: 1 / 24 }); // expires in 1 hour
      }  
    });

    if ($(this).attr('data-dependent-field-visibility') === 'hidden') {
      $(this).datepicker("destroy");
      $(this).hide();
    }
  });

  $("#tnc-button").click(function(e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $(".form-footer").offset().top
    }, 1000);
  });

  // Show field name to make admin easier finding it in the preview page
  if ($('#is_preview').val() === 'true') {
    let previousFieldName;
    $('[name]').not('input[type=hidden]').each(function() {
      let $this = $(this);

      if (previousFieldName === $this.attr('name')) {
        return;
      }

      let parentElement = $this.attr('type') === 'checkbox' ? $this.parent().parent() : $this.parent();
      parentElement.append('<em><small class="text-secondary">*Field name: <strong class="field-name">'+ $this.attr('name') +'</strong></small></em>');

      previousFieldName = $this.attr('name');
    });
  }

  // Custom validation to override default email validation in jquery
  $.validator.methods.email = function( value, element ) {
    return this.optional( element ) || /^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test( value );
  }

  // disable scroll to change value in input type number
  $('input[type=number]').on('mousewheel', function(e) {
    $(e.target).blur();
  });

  // Limit max checkbox selection
  $('input.form-check-input').on('change', function(evt) {
    var limit_selection = Number($(this).attr('data-max-selection'))
    if (limit_selection) {
      var input_name = $(this).attr("name")
      if($(`input[name='${input_name}']:checked`).length > limit_selection) {
          this.checked = false;
      }
    }
    
  });

  $('input, select').on('change', function() {
    let parentFieldName = $(this).attr('name');
    let parentFieldValue = $(this).val()?.toLowerCase();
    let parentFieldType = $(this).attr('type');

    let $elements = $('[data-dependent-field-name="'+ parentFieldName +'"]');
    $elements.each(function() {
      let $elementSelector = $(this);

      // Remove required validation on every change to prevent required validation when the field is hidden
      toggleDependentFieldRequiredValidation({ element: $elementSelector, isRequired: false } )

      let dependentFieldValue = $elementSelector.attr('data-dependent-field-value').split(",");
      dependentFieldValue = dependentFieldValue.map(element => {
        return element.trim()?.toLowerCase();
      });
      $elementSelector.next("label.error-validation").remove();

      let isRequired = $elementSelector.attr('data-is-required') === 'true';

      let showDependentField = false

      // if input type is checkbox, check if one of checked value included in dependent value
      if (parentFieldType === "checkbox") {
        $(`input:checkbox[name="${parentFieldName}"]:checked`).each(function() {
          if (dependentFieldValue.includes(this.value?.toLowerCase())) {
            showDependentField = true;
          }
       });
      } else if (dependentFieldValue.includes(parentFieldValue)) {
        showDependentField = true
      }

      if (showDependentField) {
        // Dynamically add required validation so the form will be validated when shown
        toggleDependentFieldRequiredValidation({ element: $elementSelector, isRequired } )

        $elementSelector.prop("disabled", false);
        $elementSelector.attr('data-dependent-field-visibility', 'visible');
        $elementSelector.removeClass('d-none');
        $elementSelector.next(".select2-container").removeClass('d-none');
        if ($elementSelector.hasClass('datepicker')) {
          $elementSelector.show();
          $elementSelector.datepicker({
            format: "yyyy-mm-dd",
          });
        }
      } else {
        hideElement($elementSelector)
        hideDependentChildElement($elementSelector)
      }
    });
  });

  function toggleDependentFieldRequiredValidation({ element, isRequired = false } ) {
    let methodName = isRequired ? 'addClass' : 'removeClass';
    let labelForAttribute = 'id'

    if (element.attr('type') === 'file') {
      element.parent()[methodName]('file-required');
    } else if (element.attr('type') === 'checkbox') {
      element.parent().parent()[methodName]('is-required');
      labelForAttribute = 'name';
    } else if (element.attr('type') === 'radio') {
      element.parent().parent().parent()[methodName]('is-required');
      labelForAttribute = 'name';
    } else {
      element.attr('required', isRequired);
      element[methodName]('required');
    }

    // Add required class to label
    let $label = $('label[for="'+ element.attr(labelForAttribute) +'"]');
    $label[methodName]("required");
  }

  function hideDependentChildElement(element, previous_element_names = []) {
    let dependentChilds = $(`[data-dependent-field-name='${element.attr('name')}']`)
    if (dependentChilds.length === 0) return;
    if (previous_element_names.includes(element.attr('name'))) return;

    previous_element_names.push(element.attr('name'))
    dependentChilds.each(function() {
      hideElement($(this))
      hideDependentChildElement($(this), previous_element_names)
    })
  }

  function hideElement(element) {
    element.removeAttr('required');
    element.prop("disabled", true);
    element.attr('data-dependent-field-visibility', 'hidden');
    element.addClass('d-none');
    element.next(".select2-container").addClass('d-none');
    if (element.hasClass('datepicker')) {
      element.datepicker("destroy");
      element.hide();
    }
    element.prop('checked',false);
    if (element.attr('type') === 'file') {
      element.parent().removeClass('file-required');
    }
  }

  $('.form-control-file').on('change', async function() {

    var input_element = $(this)
    var input_id = input_element.attr('id')

    $(`label.validation-error-text-${input_id}`).remove();

    let file_urls = []
    for (let i = 0; i < this.files.length; i++) {
      var size = (this.files[i].size / 1024 / 1024).toFixed(2);

      if (size > 10) {
        input_element.after(
          `<label class='ml-1 text-danger validation-error-text-${input_id}'>File Size Maximum is 10 MB</label>`,
        );
        return
      }

      Swal.fire({
        title: 'Uploading File...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      try {
        let response = await uploadFile(this.files[i])
        file_urls.push(response.data.s3URL)
      } catch (error) {
        Swal.close();
        await Swal.fire({
          title: 'Gagal Mengupload file',
          text: 'Mohon ulangi kembali',
          icon: 'error',
          confirmButtonColor: '#763cb0',
          confirmButtonText: 'Close',
        });
        input_element.val("")
        return
      }
      Swal.close();
    }

    $(`#${input_id}_urls`).val(JSON.stringify(file_urls));
  });

  var ocrModalFileMapStatus = {}
  var ocrModalProgressPercentage = 0;
  var ocrModalFileUploadName = '';
  var ocrModalRawOcrResponse = null
  var ocrModalParsedDataMapping = null
  var ocrModalProgressTask = null
  var ocrModalSessionId = Math.random().toString(36).substring(2, 15);
  var ocrModalTraceId = null

  var ocrModalMaxFileSizeMb = $('#ocr-modal-max-file-size-mb').val();
  var ocrModalMaxFileSizeMessage = $('#ocr-modal-max-file-size-message').val();

  $('input[enable_ocr="true"]').on('click', async function (event) {    
    // add reset variable
    $(this).val(null);
    ocrModalFileMapStatus = {}
    ocrModalProgressPercentage = 0;
    ocrModalFileUploadName = '';
    ocrModalRawOcrResponse = null
    ocrModalParsedDataMapping = null 
    $('.ocr-modal-selection-state').removeClass('d-none');
    $('.ocr-modal-loading-state').addClass('d-none');    
    $('#ocr-modal-progress-bar').css('width', '0%');
    $('#ocr-modal-info-message').addClass('d-none');
    $('#ocr-modal-error-message').addClass('d-none');
    $('#ocr-modal-selected-files').html('');
    $('#ocr-modal-submit').removeClass('d-none').html('Submit');
  });

  $('input[enable_ocr="true"]').on('change', async function (event) {
    let listFileElement = '';
    ocrModalFileUploadName = $(this).attr('name');
    let formInputName = $(this).attr('form_input_name');
    if(!$(`input[enable_ocr_form_input_name="${formInputName}"]`).is(":checked")){
      return
    }

    $('#ocr-modal').modal('show');
    // pre processing status map
    for await (let file of event.target.files) {
      if(file.size > parseInt(ocrModalMaxFileSizeMb) * 1024 * 1024){
          ocrModalShowErrorMessage(ocrModalMaxFileSizeMessage);
          $('#ocr-modal-submit').addClass('d-none');
        return
      }
      ocrModalFileMapStatus[file.name] = {
        s3URL: null,
        file: file,
        ocrResult: null
      }
      listFileElement += `<li>${file.name}</li>`
    }
    $('#ocr-modal-selected-files').html(`<ol>${listFileElement}</ol>`);
  });

  async function uploadFile(file, maxRetries = 3) {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('presetID', 'reward-form');
    formData.append('contentType', file.type);
    formData.append('path', `${$("#reward_form_submission_reward_form_id").val()}/`);

    for (let i = 0; i < maxRetries; i++) {
      try {
        let response = await $.ajax({
          url: "https://gw.ruangguru.com/file-uploader/upload",
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
        });
        return response;
      } catch (error) {
        if (i === maxRetries - 1) {
          throw error;
        }
      }
    }
  }

  async function submitOcrImage(file, maxRetries = 3) {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('presetID', 'roboguru');
    formData.append('path', 'reward-form/ocr/');

    for (let i = 0; i < maxRetries; i++) {
      try {
        let response = await $.ajax({
          url: "https://gw.ruangguru.com/file-uploader/upload",
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
        });
        return response;
      } catch (error) {
        if (i === maxRetries - 1) {
          throw error;
        }
      }
    }
  }

  async function ocrExtractor(params, maxRetries = 3) {
    params['llm_session_id'] = ocrModalSessionId
    params['llm_trace_id'] = ocrModalTraceId    
    let token = $('.user_identifier_value').val()
    for (let i = 0; i <= maxRetries; i++) {
      try {
        let response = await $.ajax({
          url: '/api/v1/rg-llm/ocr_extractor',
          type: 'POST',
          data: JSON.stringify(params),
          dataType: 'json',
          contentType: 'application/json',
          headers: {
            Authorization: token
          }
        });
        return response;
      } catch (error) {
        if (i >= maxRetries) throw error;
      }
    }
  }

  async function dataMapping(params, maxRetries = 3) {
    params['llm_session_id'] = ocrModalSessionId
    params['llm_trace_id'] = ocrModalTraceId

    let token = $('.user_identifier_value').val()
    for (let i = 0; i <= maxRetries; i++) {
      try {
        let response = await $.ajax({
          url: '/api/v1/rg-llm/data_mapping',
          type: 'POST',
          data: JSON.stringify(params),
          dataType: 'json',
          contentType: 'application/json',
          headers: {
            Authorization: token
          }          
        });
        return response;
      } catch (error) {
        if (i >= maxRetries) throw error;
      }
    }
  }

  function ocrModalShowErrorMessage(message) {
    $('#ocr-modal-error-message').text(message);
    $('#ocr-modal-error-message').removeClass('d-none');
  }

  function ocrModalShowInfoMessage(message) {
    $('#ocr-modal-info-message').text(message);
    $('#ocr-modal-info-message').removeClass('d-none');
  }

  function increaseProgressPercentage(t, max) {
    if (ocrModalProgressPercentage >= max) {
      return
    }
    if(ocrModalProgressPercentage >= 100){
      return
    }
    ocrModalProgressPercentage += t
    $('#ocr-modal-progress-bar').css('width', `${ocrModalProgressPercentage}%`);
  }
  
  $('#ocr-modal-submit').on('click', async function () {
    $('.ocr-modal-selection-state').addClass('d-none');
    $('.ocr-modal-loading-state').removeClass('d-none');
    $('#ocr-modal-error-message').addClass('d-none');
    let fileMapStatusKeys = Object.keys(ocrModalFileMapStatus)
    ocrModalTraceId = Math.random().toString(36).substring(2, 15);

    let reward_form_id = $(`input[name="${ocrModalFileUploadName}"]`).attr('reward_form_id')
    let form_input_name = $(`input[name="${ocrModalFileUploadName}"]`).attr('form_input_name')

    // Progress counting
    ocrModalProgressTask = setInterval(() => {
      increaseProgressPercentage(1, 100)
    }, 1000);

    // upload files
    tracker("rgFormOCRProcess", {
      ocr_processing_state: 'uploading_files_start',
    })
    ocrModalShowInfoMessage('Uploading files to server...');
    for (const fileKey of fileMapStatusKeys) {
      let fileStatusMap = ocrModalFileMapStatus[fileKey]

      if (fileStatusMap.s3URL) {
        continue
      }

      try {
        let response = await submitOcrImage(fileStatusMap.file)
        fileStatusMap.s3URL = response.data.s3URL
        let t = 30 / fileMapStatusKeys.length
        increaseProgressPercentage(t, 30)
      } catch (error) {
        ocrModalShowErrorMessage('Failed to upload file: ' + fileKey)
        $('#ocr-modal-submit').html('Coba lagi');
        clearInterval(ocrModalProgressTask)
        return
      }
    }
    tracker("rgFormOCRProcess", {
      ocr_processing_state: 'uploading_files_success',
    })
    // Extract OCR from image
    if (!ocrModalRawOcrResponse) {
      tracker("rgFormOCRProcess", {
        ocr_processing_state: 'extract_ocr_from_image_start',
      })      
      ocrModalShowInfoMessage('Extracting ocr from image...');
      let promises = [];
      try {
        for (const fileKey of fileMapStatusKeys) {
          let fileStatusMap = ocrModalFileMapStatus[fileKey];
          promises.push(
            ocrExtractor({
              image_urls: [fileStatusMap.s3URL],
              reward_form_id: reward_form_id,
              form_input_name: form_input_name
            })
          );
        }
        let responses = await Promise.all(promises);
        ocrModalRawOcrResponse = responses.map(response => response.data).toString();

        increaseProgressPercentage(30, 60);
        tracker("rgFormOCRProcess", {
          ocr_processing_state: 'extract_ocr_from_image_success',
        })              
      } catch (error) {
        tracker("rgFormOCRProcess", {
          ocr_processing_state: 'extract_ocr_from_image_failed',
        })
        ocrModalShowErrorMessage('Failed to extract ocr from image.');
        $('#ocr-modal-submit').html('Try again later');
        clearInterval(ocrModalProgressTask);
        return;
      }
    }    


    // LLM for data mapping of extracted ocr
    if (!ocrModalParsedDataMapping) {
      tracker("rgFormOCRProcess", {
        ocr_processing_state: 'mapping_data_start',
      })
      ocrModalShowInfoMessage('Mapping data...');
      try {
        let response = await dataMapping({
          reward_form_id: reward_form_id,
          form_input_name: form_input_name,
          raw_data: ocrModalRawOcrResponse
        })
        ocrModalParsedDataMapping = response.data
        increaseProgressPercentage(30, 90)
        tracker("rgFormOCRProcess", {
          ocr_processing_state: 'mapping_data_success',
        })
      } catch (error) {
        tracker("rgFormOCRProcess", {
          ocr_processing_state: 'mapping_data_failed',
        })
        ocrModalShowErrorMessage('Failed to map data')
        $('#ocr-modal-submit').html('Coba lagi');
        clearInterval(ocrModalProgressTask)
        return
      }
    }


    // Parse to JSON format from string of data mapping
    try {
      ocrModalShowInfoMessage('Parsing data mapping...');
      ocrModalParsedDataMapping = JSON.parse(ocrModalParsedDataMapping)
      increaseProgressPercentage(10, 100)
    } catch (error) {
      ocrModalShowErrorMessage('Failed to parse data mapping. Please re-upload the picture')
      $('#ocr-modal-submit').addClass('d-none');
      clearInterval(ocrModalProgressTask)
      return
    }

    // Set value to target field
    let ocrModalParsedDataMappingKeys = Object.keys(ocrModalParsedDataMapping)
    for (const field of ocrModalParsedDataMappingKeys) {
      try {
        let fieldElement = $(`input[name="reward_form_submission[submission_data][${field}]"]`)
        fieldElement.val(ocrModalParsedDataMapping[field])
        fieldElement.trigger('change')
      } catch (error) {
      }
    }

    ocrModalShowInfoMessage('Finished');
    setTimeout(() => {
      $('#ocr-modal').modal('hide');
      clearInterval(ocrModalProgressTask)
    }, 1000);
  });

  
  // Save to cookie logic
  let isRestoring = true;

  $('input[type="text"], input[type="number"], textarea').on('blur', function () {
    saveValueToCookies(this.id, $(this).val());
  });

  $('select').on('change', function () {
    if (isRestoring) return;
    saveValueToCookies(this.id, $(this).val());
  });

  $('input[type="checkbox"]').on('change', function () {
    if (isRestoring) return;

    const name = $(this).attr('name');

    if (name && $(`input[name="${name}"]`).length > 1) {
        // Checkbox group
        const values = $(`input[name="${name}"]:checked`).map(function () {
            return this.value;
        }).get();

        if (values.length > 0) {
            saveValueToCookies(name, JSON.stringify(values));
        } else {
            Cookies.remove(name);
        }
    } else if (name) {
        // Single checkbox without id but with a unique name
        saveValueToCookies(name, this.checked ? '1' : '0');
    }
  });

  $('input[type="radio"]').on('change', function () {
      saveValueToCookies(this.name, this.value);
  });

  // Restore from cookie logic
  $('input[type="text"], input[type="number"], textarea').each(function () {
      const val = loadValueFromCookies(this.id);
      if (val !== undefined && $(this).val() === "") {
          $(this).val(val).trigger('change');
      }
  });

  // Restore select
  $('select').each(function () {
      const val = loadValueFromCookies(this.id);
      if (val !== undefined && $(this).val() === "") {
          $(this).val(val).trigger('change');
      }
  });

  // Restore checkboxes
  $('input[type="checkbox"]').each(function () {
    const name = $(this).attr('name');

    if (name && $(`input[name="${name}"]`).length > 1) {
        // Checkbox group
        const saved = Cookies.get(name);
        if (saved) {
            const selected = JSON.parse(saved);
            if (selected.includes(this.value)) {
                this.checked = true;
                $(this).trigger('change');
            }
        }
    } else if (name) {
        // Single checkbox with unique name
        const val = Cookies.get(name);
        if (val !== undefined) {
            this.checked = val === '1';
            $(this).trigger('change');
        }
    }
  });


  // Restore radio
  $('input[type="radio"]').each(function () {
      const val = loadValueFromCookies(this.name);
      if (val !== undefined && this.value === val) {
          this.checked = true;
          $(this).trigger('change');
      }
  });

  isRestoring = false;
});

function saveValueToCookies(id, value) {
  const COOKIE_EXPIRE_HOURS = 1;
  const expireOption = { expires: COOKIE_EXPIRE_HOURS / 24 };

  Cookies.set(id, value, expireOption);
}

function loadValueFromCookies(id) {
  const valueFromCookies = Cookies.get(id)
  if (valueFromCookies === "") {
    return
  }
  return valueFromCookies
}
